import { apiClient } from 'lib/api';
import { queryOptions } from '@tanstack/react-query';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { SYNC_FREQUENCY } from '../stores/airflowSyncStore';
import dayjs from 'dayjs';

const getAirFlowSyncDatetime = async ({
  signal,
}: QueryFunctionContext<[string]>): Promise<{ last_sync_dt: string }> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await apiClient.get<{ last_sync_dt: string }>(`/airflow_last_sync`, {
      signal,
    });

    return res.data;
  } catch (e) {
    throw e;
  }
};

export const airflowSyncDatetimeOptions = queryOptions({
  queryFn: getAirFlowSyncDatetime,
  queryKey: ['airflow_sync_datetime'],
  refetchInterval: (data) => {
    if (data.state.status === 'error') {
      return SYNC_FREQUENCY;
    }
    if (!data.state.data) {
      return 5000;
    }

    const latestSyncTime = dayjs(data.state.data.last_sync_dt);

    let nextSyncTime = latestSyncTime.add(SYNC_FREQUENCY, 'milliseconds');

    while (nextSyncTime.isBefore()) {
      nextSyncTime = dayjs().add(30000);
    }

    const timeRemainingMs = nextSyncTime.diff(dayjs());

    return timeRemainingMs;
  },
  refetchOnWindowFocus: true,
  staleTime: 5000,
  retry: 2,
});
